import React, { Fragment, FunctionComponent, ReactNode } from "react";

import { config } from "../../config/config";

const breakDealerName = (delaerName: string): ReactNode => {
  const words = delaerName.trim().split(/\s+/);
  const midIndex = Math.ceil(words.length / 2);
  const firstHalf = words.slice(0, midIndex).join(" ");
  const secondHalf = words.slice(midIndex).join(" ");
  return [firstHalf, secondHalf].map((chunk, i) => (
    <Fragment key={chunk}>
      {i > 0 && <br />}
      {chunk}
    </Fragment>
  ));
};

export const DealerName: FunctionComponent<{ children: ReactNode }> = ({
  children,
}) => {
  return (
    <h3 className="tw-header__dealer">
      {config.forceBreakDealerName && typeof children === "string"
        ? breakDealerName(children)
        : children}
    </h3>
  );
};
